export const defaultTarjetaEmergencia = () => {
    return {
        id: '',
        id_producto: '',
        version_sga: '',
        fecha_elaborado: '',
        controlesingenieria: '',
        proteccion_respiratoria: '',
        proteccion_manos: '',
        proteccion_ojos: '',
        proteccion_piel_cuerpo: '',
        parametrosexposicionacgih: '',
        estabilidad: '',
        incompatibilidades: '',
        condicionesevitar: '',
        productosdescomposicion: '',
        inhalacion: '',
        ingestion: '',
        piel: '',
        ojos: '',
        notasmedico: '',
        riesgoincendio: '',
        tempinflamabilidad: '',
        medioextintorapropiado: '',
        equipprotespecialbomberos: '',
        precaucionesespeciales: '',
        precaucionesindividuales: '',
        precaucioprotmedambiente: '',
        metodoslimpieza: '',
        mensajeet: '',
        letrasga: '',
        frasesga: '',
    }
}

export const defaultAsignacionTarjetaEmergencia = () => {
    return { 
        id_empresa: '',
        id_producto: '',
        pdf: '',
        estado: 0,
        date: ''
    }
}

export default {

    selectedTarjetaEmergencia: defaultTarjetaEmergencia(),
    asignacionTarjetaEmergencia: defaultAsignacionTarjetaEmergencia(),
    accionTarj: 'crear',
    errorTarj: false,
    verTarjeta: false,

    pdf: {
        producto: '',
        version: '',
        empresa: '',
        rol: '',
        modeloTarjeta: '',
    },

    pdf_generado: {
        path: '',
        title: '',
        message: '',
        warn_msg: '',
    },
}